var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCardSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.25C2.92893 3.25 1.25 4.92893 1.25 7V17C1.25 19.0711 2.92893 20.75 5 20.75H19C21.0711 20.75 22.75 19.0711 22.75 17V7C22.75 4.92893 21.0711 3.25 19 3.25H5ZM12.1057 15.2114C11.1559 13.9109 9.83882 13.2389 8.47596 13.257C7.12087 13.2751 5.82568 13.9738 4.90076 15.2027C4.7298 15.4299 4.70197 15.7342 4.8289 15.9886C4.95583 16.243 5.2157 16.4037 5.5 16.4037H11.5C11.7824 16.4037 12.0408 16.2452 12.1687 15.9934C12.2966 15.7417 12.2722 15.4394 12.1057 15.2114ZM8.5 8.25C7.39543 8.25 6.5 9.14543 6.5 10.25C6.5 11.3546 7.39543 12.25 8.5 12.25C9.60457 12.25 10.5 11.3546 10.5 10.25C10.5 9.14543 9.60457 8.25 8.5 8.25ZM14 9.25C13.5858 9.24999 13.25 9.58577 13.25 9.99998C13.25 10.4142 13.5858 10.75 14 10.75L19 10.7501C19.4142 10.7501 19.75 10.4144 19.75 10.0001C19.75 9.58593 19.4142 9.25013 19 9.25012L14 9.25ZM14 13.25C13.5858 13.25 13.25 13.5858 13.25 14C13.25 14.4142 13.5858 14.75 14 14.75L17 14.7501C17.4142 14.7501 17.75 14.4144 17.75 14.0002C17.75 13.5859 17.4142 13.2501 17 13.2501L14 13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCardSolidStandard);
export default __webpack_public_path__ + "static/media/student-card-solid-standard.74f4a9f606a409b8b3d000311b42e0df.svg";
export { ForwardRef as ReactComponent };